<template>
  <div id="special-offer-document" class="overlay-content">
    <table width="100%">
      <tr>
        <td width="100%"  align="center">
          <p><img v-if="getHotelLogo() !== ''" width="150px" alt="Contract Manager logo" :src="getHotelLogo()" id="sp-hotel-logo"></p>
        </td>
      </tr>
    </table>
    <div id="special-offer-detail">
      <header-information-component
        :special-offer-detail="specialOfferDetail"
        :is-template="isTemplate"
        :agent="agent"
      ></header-information-component>
      <div id="doc-special-offer-detail">
        <div style="margin: 60px 0">
          <div style="font-weight: bold">
            <p>Dear
              <span class="helping-tag" v-if="isTemplate"> Contact Name</span>
              <span v-else> {{ getContactName() }} </span>
            </p>
          </div>
          <p id="body-message" style="margin: 50px 0 !important;" v-html="bindBodyMessage()"></p>
        </div>
        <promotion-detail-component
          :special-offer-detail="specialOfferDetail"
          :room-type-list="roomTypeList"
        ></promotion-detail-component>
        <p id="footer-message" v-html="bindFooterMessage()"></p>
      </div>
      <signed-component
        :special-offer-detail="specialOfferDetail"
        :is-template="isTemplate"
        :agent="agent"
      ></signed-component>
      <div id="ref-code">
        <p>
          Ref code: {{specialOfferDetail.refCode}}/<span v-if="isTemplate" class="helping-tag">{{ bindRefCodeSuffixType() }}</span><span v-else>{{ agent.name }}</span>
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import { SPECIAL_OFFER_REF_CODE_TYPE, SPECIAL_OFFER_STATUS, STATUS } from '@/configs/constant'
import HeaderInformationComponent from '../PreviewSpecialOffer/HeaderInformationComponent'
import PromotionDetailComponent from '../PreviewSpecialOffer/PromotionDetailComponent'
import SignedComponent from '../PreviewSpecialOffer/SignedComponent'
import { get } from 'lodash'
import { applyMessageTableStyle } from '@/domains/special-offer-domain'

export default {
  name: 'DocumentContainerComponent',
  components: {
    HeaderInformationComponent,
    PromotionDetailComponent,
    SignedComponent
  },
  props: {
    specialOfferDetail: {
      type: Object,
      default: () => {
        return {
          autoRefCode: STATUS.DISABLE,
          status: SPECIAL_OFFER_STATUS.DRAFT,
          refCode: '',
          refCodeSuffixType: SPECIAL_OFFER_REF_CODE_TYPE.AGENT_NAME,
          hotel: {
            id: '',
            information: {
              code: '',
              name: ''
            },
            salePerson: {
              id: '',
              title: '',
              firstName: '',
              lastName: '',
              position: '',
              email: '',
              updatedAt: ''
            }
          },
          promotion: {
            promotion: {
              id: '',
              code: '',
              detail: '',
              minNight: 0,
              maxNight: 0,
              isEnable: 0,
              updatedAt: 0,
              bookingPeriod: {
                startDate: '',
                endDate: ''
              },
              periodOfStayList: [],
              isEnableAllotment: 0,
              roomTypeList: []
            }
          },
          agentList: [],
          general: {
            startDate: '',
            endDate: '',
            issueDate: '',
            internalNote: '',
            footerMessage: '',
            bodyMessage: ''
          }
        }
      }
    },
    hotel: {
      type: Object,
      default: () => {
        return {}
      }
    },
    roomTypeList: {
      type: Array,
      default: () => {
        return []
      }
    },
    agent: {
      type: Object,
      default: () => {
        return {
          name: '',
          information: {
            address: '',
            country: '',
            emailList: [],
            faxList: [],
            phoneList: [],
            zipCode: ''
          },
          contactPerson: {
            emailList: [],
            firstName: '',
            lastName: '',
            title: '',
            position: ''
          }
        }
      }
    },
    isTemplate: {
      type: Boolean,
      default: true
    }
  },
  methods: {
    getHotelLogo: function () {
      const logoUrl = get(this.hotel, 'logoUrl', '')
      return logoUrl
    },
    bindRefCodeSuffixType: function () {
      switch (this.specialOfferDetail.refCodeSuffixType) {
        case SPECIAL_OFFER_REF_CODE_TYPE.AGENT_NAME:
          return 'Agent Name'
        default:
          return 'N/A'
      }
    },
    getContactName: function () {
      const title = get(this.agent, 'contactPerson.title', '')
      const firstName = get(this.agent, 'contactPerson.firstName', '')
      const lastName = get(this.agent, 'contactPerson.lastName', '')

      const fullName = `${title}${firstName} ${lastName}`
      if (fullName.trim() === '') {
        return '-'
      }

      return fullName
    },
    bindBodyMessage: function () {
      const bodyMessage = get(this.specialOfferDetail, 'general.bodyMessage', '')
      const appliedMessage = _applyMessageTableStyle(bodyMessage)

      return appliedMessage
    },
    bindFooterMessage: function () {
      const footerMessage = get(this.specialOfferDetail, 'general.footerMessage', '')
      const appliedMessage = _applyMessageTableStyle(footerMessage)

      return appliedMessage
    }
  }
}

function _applyMessageTableStyle (message) {
  const newMessage = message.replace(/(?:\r\n|\r|\n)/g, '<br>')
  const appliedMessage = applyMessageTableStyle(newMessage)

  return appliedMessage
}
</script>

<style scoped>
  .overlay-content {
    position: relative;
    top: 10%;
    margin-top: 30px;
    overflow-y: scroll;
    font-size: 18px;
    width: calc(100% - 200px);
    padding-left: 100px;
    padding-right: 100px;
    padding-bottom: 100px;
  }
  .helping-tag {
    background-color: #78C0D8;
    color: #ffffff;
    font-weight: 600;
    padding: 3px 10px;
    border-radius: 15px;
    font-size: 15px;
  }
</style>
